import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import { TextField } from "@mui/material";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const DatePicker = (props) => {
	const { value, onChange, style, ...rest } = props;

	const [open, setOpen] = useState(false);

	const defaultSx = { width: '100%', backgroundColor: 'white' };

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<MuiDatePicker
				open={open}
				onOpen={() => setOpen(true)}
				onClose={() => setOpen(false)}
				renderInput={(params) => (
					<TextField
						{...params}
						onClick={() => setOpen(true)}
						{...rest}
					/>
				)}
				// format="YYYY-MM-DD"
				value={!value ? null : moment.utc(value)}
				onChange={onChange}
				sx={style ? style : defaultSx}
				{...rest}
			/>
		</LocalizationProvider>
	);
};

DatePicker.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
};

export default DatePicker;
